module.exports = __webpack_public_path__ + "img/number_9.a978306c.png";